import {
  selectIsLanguageSelectorDialogOpen,
  selectIsLanguageSelectorDialogForced,
  setIsLanguageSelectorDialogOpen,
} from "@/features/localisation/store/language-selector-slice";
import { useAppDispatch, useAppSelector } from "@/store";

import { LanguageSelectorDialog } from "./language-selector-dialog";

export const GlobalLanguageSelectorDialog = () => {
  const dispatch = useAppDispatch();

  const isForcedSelection = useAppSelector(
    selectIsLanguageSelectorDialogForced
  );

  const isDialogOpen = useAppSelector(selectIsLanguageSelectorDialogOpen);

  const hideDialog = () => {
    dispatch(setIsLanguageSelectorDialogOpen({ isOpen: false }));
  };

  return (
    <LanguageSelectorDialog
      open={isDialogOpen}
      forcedSelection={isForcedSelection}
      hideDialog={hideDialog}
    />
  );
};
